<template>
  <div>
      <div v-if="showComponent">
          <!-- <DynamicComponentTest v-bind:id="post.id" v-bind:text="post.text" @valueChangedMethodInComponent="setValueMethodInView"></DynamicComponentTest> -->
          <DynamicComponentTest v-bind="post" @valueChangedMethodInComponent="setValueMethodInView"></DynamicComponentTest>
      </div>
      <h1>In view</h1>
    <!-- <ComponentTest v-bind="post"></ComponentTest> -->
    <v-btn @click="setRegId(2)">Set ID 2</v-btn>
    <v-btn @click="setRegId(3)">Set ID 3</v-btn>
    <v-btn @click="setRegId(4)">Set ID 4</v-btn>
    <v-btn @click="showComponent = !showComponent">Hide</v-btn>
    ValueFromComponent: {{valueInComponent}}
  </div>
</template>


<script>
//import ComponentTest from "@/components/Admin/ComponentTest.vue"; //Denne vil rendre umiddelbart

export default {
  data() {
    return {
        post: {
            id: 1,
            text: "Tekst i post"
        },
      regId: Number,
      text: String,
      showComponent: Boolean,
      compValue: String,
      valueInComponent: String
    };
  },
  created() {
      this.showComponent = false;
      this.valueInComponent = "Initial value in view"
  },
  methods: {
    setRegId(regId) {
      this.post.id = regId;
      this.post.text = "Ny text from " + regId;
      this.showComponent = true;
    },
    setValueMethodInView(value) {
        this.valueInComponent = value;
    }
  },
  components: {
    DynamicComponentTest: () => import('@/components/Admin/ComponentTest.vue') //Denne rendrer ved behov <div v-if..>
  },
};
</script>